export const EARLY_ACCESS_PRO = Object.freeze({
  name: 'Kubiqa Pro',
  monthlyPriceEuros: 19,
  earlyAccessPriceEuros: 0,
  requiresCard: false,
  features: Object.freeze([
    'Property listings and publishing',
    'Lead capture and inbox',
    'Sales pipeline and opportunities',
    'Contact directory and activity history',
  ]),
});

export const EARLY_ACCESS_REGISTRATION_ROUTE = Object.freeze({
  name: 'Register',
  query: Object.freeze({ source: 'early_access' }),
});
